import React from 'react';
import { connect } from 'react-redux';
import { List } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Restaraunt from '../../../../assets/svg/restaurant';
import Home from '../../../../assets/svg/home';
import EventNote from '../../../../assets/svg/eventNote';
import PhotoLibrary from '../../../../assets/svg/photoLibrary';
import Calendar from '../../../../assets/svg/calendar';
import Forum from '../../../../assets/svg/forum';
import { withRouter } from 'react-router-dom';
import { colors, Logo, Icon } from 'kangarootime-ui';
import moment from 'moment';
import DrawerItem from './Item';

const styles = theme => ({
  toolbar: theme.mixins.toolbar
});

const DrawerContent = ({ ...props }) => {
  const CURRENT_ROUTE = props.location.pathname;
  const CURRENT_CENTER_LEGACY_PERMISSIONS = props.currentCenterInformation ? props.currentCenterInformation.permissions : {};

  let drawerItems = [
    { label: 'Home', route: '/home', icon: <Home fill={/^\/home/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} /> }
  ];

  if (CURRENT_CENTER_LEGACY_PERMISSIONS.admin) {
    drawerItems.push({
      label: 'Scheduling',
      route: '/scheduling',
      icon: <EventNote fill={/^\/scheduling/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />,
      badgeCount: props.pendingTimeOffRequests.length
    });
  }

  if (CURRENT_CENTER_LEGACY_PERMISSIONS.admin && props.featureFlagMenus) {
    drawerItems.push({
      label: 'Nutrition',
      route: '/menus',
      icon: <Restaraunt fill={/^\/menus/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />
    });
  }

  if (
    props.featureFlagGallery &&
     (CURRENT_CENTER_LEGACY_PERMISSIONS.admin || CURRENT_CENTER_LEGACY_PERMISSIONS.gallery)
  ) {
    drawerItems.push({
      label: 'Gallery',
      route: '/gallery',
      icon: <PhotoLibrary fill={/^\/gallery/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />,
      badgeCount: props.photosPendingApproval.length
    });
  }

  if (
    props.featureFlagEvents &&
    (CURRENT_CENTER_LEGACY_PERMISSIONS.admin || CURRENT_CENTER_LEGACY_PERMISSIONS.calendar)
  ) {
    drawerItems.push({
      label: 'Events',
      route: '/events',
      icon: <Calendar fill={/^\/events/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />
    });
  }

  if (
    props.featureFlagMessaging &&
    (CURRENT_CENTER_LEGACY_PERMISSIONS.admin || CURRENT_CENTER_LEGACY_PERMISSIONS.messages)
  ) {
    drawerItems.push({
      label: 'Messages',
      route: '/messages',
      icon: <Forum fill={/^\/messages/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />,
      badgeCount: props.unreadMessageCount
    });
  }

  if (props.featureFlagEmployeeAttendance && CURRENT_CENTER_LEGACY_PERMISSIONS.admin) {
    drawerItems.push({
      label: 'Attendance',
      route: '/attendance/employee',
      icon: <Icon icon='clock' color={/^\/attendance/.test(CURRENT_ROUTE) ? colors.brand_2 : colors.white} />
    });
  }

  return (
    <React.Fragment>
      <div className={props.classes.toolbar} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ margin: '0 8px' }}>
          <Logo type='white' />
        </div>
      </div>
      <List>
        {drawerItems.map((item, index) => {
          const route = item.route;
          const regexString = `^${route}`;
          const regex = new RegExp(regexString);

          return (
            <DrawerItem
              key={index}
              route={item.route}
              label={item.label}
              icon={item.icon}
              badgeCount={item.badgeCount}
              isActiveRoute={regex.test(CURRENT_ROUTE)}
            />
          );
        })}
      </List>
    </React.Fragment>
  );
};

function mapStateToProps (state) {
  return {
    featureFlagMenus: state.identity.flags.menus,
    featureFlagGallery: state.identity.flags['new-gallery'],
    featureFlagEvents: state.identity.flags['new-events'],
    featureFlagMessaging: state.identity.flags['new-messaging'],
    featureFlagEmployeeAttendance: state.identity.flags['new-employee-attendance'],
    photosPendingApproval: state.gallery.overview.pending.photosPendingApproval,
    pendingTimeOffRequests: state.scheduling.timeOffRequests.all.filter(req => req.status === undefined && moment(req.start).isAfter(moment())),
    currentCenterInformation: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0],
    unreadMessageCount: state.messages.unreadMessageCount
  };
}

function mapDispatchToProps () {
  return {

  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(DrawerContent)));
